import { CustomSelectFieldProps, SelectField } from 'components/form'
import { GrupoAlvoBuscaAtivaVacinacaoEnum } from 'graphql/types.generated'

export interface GrupoAlvoVacinacaoSelectModel {
  id: ID
  enum: GrupoAlvoBuscaAtivaVacinacaoEnum
  descricao: string
}

export type GrupoAlvoVacinacaoSelectFieldProps = CustomSelectFieldProps<GrupoAlvoVacinacaoSelectModel> & {
  isTipoBuscaAtivaCovid: boolean
}

export function GrupoAlvoVacinacaoSelectField(props: GrupoAlvoVacinacaoSelectFieldProps) {
  const { isTipoBuscaAtivaCovid: isTipoAcompanhamentoCovid, ...rest } = props
  const itemToString = (item: GrupoAlvoVacinacaoSelectModel) => item?.descricao

  return (
    <SelectField<GrupoAlvoVacinacaoSelectModel>
      items={items.sort((a, b) => a.id - b.id)}
      itemToString={itemToString}
      {...rest}
    />
  )
}

export const items = [
  { id: 1, enum: GrupoAlvoBuscaAtivaVacinacaoEnum.CRIANCAS, descricao: 'Crianças (0 a 9 anos)' },
  { id: 2, enum: GrupoAlvoBuscaAtivaVacinacaoEnum.ADOLESCENTES, descricao: 'Adolescentes (10 a 19 anos)' },
  { id: 3, enum: GrupoAlvoBuscaAtivaVacinacaoEnum.ADULTOS, descricao: 'Adultos (20 a 59 anos)' },
  { id: 4, enum: GrupoAlvoBuscaAtivaVacinacaoEnum.IDOSOS, descricao: 'Pessoas idosas (60 anos ou mais)' },
  { id: 5, enum: GrupoAlvoBuscaAtivaVacinacaoEnum.GESTANTES_E_PUERPERAS, descricao: 'Gestantes/Puérperas' },
]
